<template>
<section>
  <base-row>
    <base-column>
      <base-heading :type-array="['Expert in', 'knowledge in']">
        <template v-slot:default>My Skills</template>
        <template v-slot:sub>Expert in</template>
      </base-heading>
    </base-column>
    <base-column class="mb-2" v-for="skill in skills" :col-xs="4" :key="skill" :col-sm="3" :col="2">
      <skill-item :icon="skill" :title="skill">
      </skill-item>
    </base-column>
  </base-row>
</section>
</template>

<script>
import BaseRow from "@/components/base/BaseRow";
import BaseColumn from "@/components/base/BaseColumn";
import BaseHeading from "@/components/base/BaseHeading";
import SkillItem from "@/components/strengths/skills/SkillItem";
export default {
  name: "TheSkills",
  components: {SkillItem, BaseHeading, BaseColumn, BaseRow},
  computed: {
    skills(){
      return this.$store.getters['skills/getSkills'];
    }
  }
}
</script>

<style scoped>

</style>